<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Social Activities'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="11"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Social Activities</div>
            <activity-component v-for="ac in ac1" :key="ac" :activity="ac"></activity-component>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "SocialActivities",
  components: {
    NavbarComponent,KeyRecruiters,
    PageHeader,
    Sidebar,
    FooterComponent,
    ActivityComponent
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      ac1: [
        {
          name: "Special Winter Camp at Chichudi Kh",
          date: "1 July 2021",
          details: "The National Service Scheme has been in existence in SND College of Engineering ever since 2009. Even before the launching of this scheme, all the college programmes were guided by the philosophy of extension, and the role of co-curricular activities for the all round development of students has been acknowledged. The National Service Scheme thus continues to uphold and reinforce these traditions with dignity and pride.",
          images: [
            {
              "itemImageSrc": "/static/images/it/socialActivity/ac1/s2.jpg",
              "thumbnailImageSrc": "",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },

          ]
        },
        {
          name: "Yoga Day Celebration on 21 June 2021",
          date: "21 June 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/it/socialActivity/ac1/s1.jpg",
              "thumbnailImageSrc": "",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },

          ]
        },
      ],
    }
  }
}
</script>
<style lang="scss" scoped/>
